import { render, staticRenderFns } from "./RevisionMutationGroupV2.vue?vue&type=template&id=7b58fc34&"
import script from "./RevisionMutationGroupV2.vue?vue&type=script&lang=js&"
export * from "./RevisionMutationGroupV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports